export const BRAND_NAME = "Росомахатул";

/** VAT rate already included in every displayed price. */
export const VAT_RATE = 0.22;

/**
 * Label for the cart summary row; derived so the rate can never drift from `VAT_RATE`.
 * "(товары)" is load-bearing: the row sits under "Итого", which also includes delivery,
 * while the figure covers goods only.
 */
export const VAT_LABEL = `В т.ч. НДС ${VAT_RATE * 100}% (товары)`;

/** Shown next to every catalog price: B2B buyers compare offers with and without VAT. */
export const PRICE_VAT_NOTE = "с НДС";

/** VAT already contained in a gross amount (≈18% of it), not `gross × VAT_RATE`. */
export const vatIncludedIn = (grossAmount: number) =>
  Math.round((grossAmount * VAT_RATE) / (1 + VAT_RATE));

/**
 * Single source of truth for company contact details. These used to be copied into
 * Header, Footer, Contacts, Terms, Privacy and Delivery, and had already drifted —
 * Delivery advertised different opening hours than every other page.
 */
export const CONTACTS = {
  phone: "+7 (495) 011-15-37",
  /** Digits only, for tel: hrefs. */
  phoneHref: "tel:+74950111537",
  email: "info@rosomaha-tools.ru",
  emailHref: "mailto:info@rosomaha-tools.ru",
  address: "г. Москва, п. Толстопальцево, ул. Советская, д. 1, стр. 1",
  workingHours: "Пн-Пт: 09:00 - 17:00",
  weekend: "Сб, Вс: выходной",
} as const;
